import { gql } from '@apollo/client';

export const REQUEST_SUBSIDY = gql`
  mutation RequestSubsidy($input: RequestSubsidyInput!) {
    requestSubsidy(input: $input) {
      subsidyRequestId
      oem
      customer
      dealer
      lender
      term
      financeAmount
      subsidyPercentage
      dnetPercentage
      dnet
      approvedSubsidyAmount
      equipment {
        id
        year
        make
        model
        serialNumberVin
      }
    }
  }
`;
